import { InjectionToken } from '@angular/core';

export const SESSION_STORAGE = new InjectionToken<Storage>('This token provides browser session storage', {
  providedIn: 'root',
  factory: (): Storage => sessionStorage,
});
